import React from 'react';
import { HdRbacButton } from '../../../components';
import { HdRbacButtonProps } from '../../../access-control/components/rbac-button/HdRbacButton';

export interface PlayButtonProps extends HdRbacButtonProps {
  paused: boolean;
  pause: Function;
  play: Function;
}

export const PlayButton = React.forwardRef<any, PlayButtonProps>(({
  paused,
  pause,
  play,
  ...others
}: PlayButtonProps, ref) => {
  return (
    <HdRbacButton
      {...others}
      icon={paused ? 'play' : 'pause'}
      iconClassName='icon-size-2'
      size='sm'
      variation='outline'
      tooltipContent={paused ? 'Resume' : 'Pause'}
      onClick={(e) => {
        if (paused) {
          play();
        } else {
          pause();
        }

        if (others.onClick) {
          others.onClick(e);
        }
      }}
      ref={ref}
    >
      {!others.iconOnly ? (paused ? 'Resume' : 'Pause') : ''}
    </HdRbacButton>
  );
});
